import { DailyLessonVolume } from './daily_lesson_volume';
export class DailyLesson {
    constructor(data, config) {
        var _a;
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nameWithNewLine", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consecutiveRecordDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompletedToday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "volumes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentVolumeRemainingLessonCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextVolumeLessonCounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.nameWithNewLine = data.nameWithNewLine;
        this.description = data.description;
        this.consecutiveRecordDays = data.consecutiveRecordDays;
        this.isCompletedToday = data.isCompletedToday;
        this.volumes = data.volumes ? data.volumes.map((o) => new DailyLessonVolume(o, config)) : [];
        this.currentVolumeRemainingLessonCount = data.currentVolumeRemainingLessonCount;
        this.nextVolumeLessonCounts = (_a = data.nextVolumeLessonCounts) !== null && _a !== void 0 ? _a : [];
    }
    currentDay() {
        var _a;
        const currentDay = this.volumes.flatMap((volume) => volume.days).find((day) => day.isCurrent);
        if (!((_a = currentDay === null || currentDay === void 0 ? void 0 : currentDay.dailyLessonDayLesson) === null || _a === void 0 ? void 0 : _a.lesson)) {
            return null;
        }
        return currentDay;
    }
}
const PREVIEW_DAILY_LESSON_ID = 0;
export const buildHomeUndiagnosedPreviewDailyLesson = (config) => {
    const dailyLesson = {
        id: PREVIEW_DAILY_LESSON_ID,
        name: '',
        nameWithNewLine: '',
        description: '',
        consecutiveRecordDays: 0,
        isCompletedToday: false,
        currentVolumeRemainingLessonCount: 3,
        nextVolumeLessonCounts: [5, 5],
        volumes: [],
    };
    const volumes = [
        {
            id: 1,
            volumeNumber: 1,
            isCompleted: false,
            isCurrentVolume: true,
            totalLessons: 3,
            finishedDays: 0,
            dailyLesson: dailyLesson,
            days: [
                {
                    id: -1,
                    dailyLessonVolumeId: 1,
                    day: 1,
                    isCurrent: true,
                    isCompleted: false,
                    completedCount: 0,
                    dailyLessonDayLesson: null,
                },
            ],
        },
    ];
    return new DailyLesson(Object.assign(Object.assign({}, dailyLesson), { volumes }), config);
};
export const isHomeUndiagnosedPreviewDailyLesson = (dailyLesson) => {
    return dailyLesson.id === PREVIEW_DAILY_LESSON_ID;
};
export const findHomeUndiagnosedPreviewFirstDay = (dailyLesson) => {
    var _a, _b;
    if (!isHomeUndiagnosedPreviewDailyLesson(dailyLesson)) {
        return null;
    }
    return (_b = (_a = dailyLesson.volumes.find((volume) => volume.volumeNumber === 1)) === null || _a === void 0 ? void 0 : _a.days.find((day) => day.isCurrent)) !== null && _b !== void 0 ? _b : null;
};
